import { PropTypes } from 'prop-types';

import Input from 'components/input/input';
import Textarea from 'components/textarea/textarea';
import Radio from 'components/radio/radio';
import DateTimePicker from 'components/date_time_picker/date_time_picker';
import Checkbox from 'components/checkbox/checkbox';

import { ReactComponent as ArrowRightSVG } from 'icons/arrow-right.svg';

import {
  ALD_OPTIONS,
  MALADIE_OPTIONS,
  PRESCRIPTION_OPTIONS,
  PRESCRIPTION_TYPE_OPTIONS,
  CPAP_DEVICE_TYPE_OPTIONS,
  EXAMINATION_OPTIONS,
} from 'config/document';

const ViewComponent = ({
  document,
  validation,
  onChange,
  onCheckboxChange,
  onRadioChange,
  onDateChange,
  onSubmit,
  isSubmitting,
}) => {
  return (
    <main className="th-main">
      <section className="th-canvas">
        <header className="th-canvas-header">
          <h2 className="th-canvas-title">
            <span>Documents</span>
            <span>
              <ArrowRightSVG />
            </span>
            Update fields
          </h2>
          <section className="view-actions">
            <button className="btn-green" data-cy="submit" onClick={onSubmit}>
              Review & Sign
            </button>
          </section>
        </header>
        <div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">
            Personne recevant les soins et assuré(e)
          </h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <Input
                  name="name"
                  label="Nom et prénom du patient*"
                  value={document.name}
                  valid={validation.name}
                  validationText="This question is required!"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="carteVitale"
                  label="Numéro d'immatriculation du patient*"
                  value={document.carteVitale}
                  valid={validation.carteVitale}
                  validationText={
                    !document.carteVitale
                      ? 'This question is required!'
                      : isSubmitting
                      ? 'Invalid input'
                      : ''
                  }
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <DateTimePicker
                  label="Date de naissance du patient*"
                  name="dateOfBirth"
                  showYearDropdown={true}
                  showTimeInput={false}
                  value={document.dateOfBirth}
                  valid={validation.dateOfBirth}
                  validationText="This question is required!"
                  onChange={(value) =>
                    onDateChange({ field: 'dateOfBirth', value })
                  }
                />
              </div>
              <div className="w-100">
                <Input
                  name="insuredName"
                  label="Nom et prénom de l'assuré(e)"
                  value={document.insuredName}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="insuredRegisstrationNumber"
                  label="Numéro d'immatriculation de l'assuré(e)"
                  valid={validation.insuredRegisstrationNumber}
                  value={document.insuredRegisstrationNumber}
                  validationText="Invalid input"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Textarea
                  name="insuredAddress"
                  label="Adresse de l'assuré(e)*"
                  value={document.insuredAddress}
                  valid={validation.insuredAddress}
                  validationText="This question is required!"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Textarea
                  name="paymentCenter"
                  label="Centre de paiement"
                  value={document.paymentCenter}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
            </div>
          </div>

          <h4 className="midlightgrey f-small fw5 ttu mt15">
            Conditions de prise en charge des soins
          </h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <Radio
                  name="maladie"
                  label="Maladie*"
                  disabled
                  value={document.maladie}
                  valid={validation.maladie}
                  validationText="This question is required!"
                  options={MALADIE_OPTIONS}
                  onChange={(event) => onRadioChange(event)}
                />
              </div>
              <div className="w-100">
                <Radio
                  name="ald"
                  label="Soins en rapport avec une ALD*"
                  value={document.ald}
                  valid={validation.ald}
                  validationText="This question is required!"
                  options={ALD_OPTIONS}
                  onChange={(event) => onRadioChange(event)}
                />
              </div>
            </div>
          </div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">
            Traitement prescrit
          </h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <Radio
                  name="prescription"
                  label="Traitement prescrit*"
                  value={document.prescription}
                  disabled
                  valid={validation.prescription}
                  validationText="This question is required!"
                  options={PRESCRIPTION_OPTIONS}
                  onChange={(event) => onRadioChange(event)}
                />
              </div>
              <div className="w-100">
                <Radio
                  name="prescriptionType"
                  label="Type de prescription*"
                  disabled
                  value={document.prescriptionType}
                  valid={validation.prescriptionType}
                  validationText="This question is required!"
                  options={PRESCRIPTION_TYPE_OPTIONS}
                  onChange={(event) => onRadioChange(event)}
                />
              </div>
              <div className="w-100">
                <Radio
                  name="cpapDeviceType"
                  label="Type de d'appareil PPC*"
                  value={document.cpapDeviceType}
                  valid={validation.cpapDeviceType}
                  validationText="This question is required!"
                  options={CPAP_DEVICE_TYPE_OPTIONS}
                  onChange={(event) => onRadioChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="pressure"
                  label="Pression ou intervalle de pression (cm H2O)*"
                  value={document.pressure}
                  valid={validation.pressure}
                  validationText="This question is required!"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="settings"
                  label="Réglage particulier"
                  value={document.settings}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="interface"
                  label="Type d'interface"
                  value={document.interface}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="model"
                  label="Marque et modèle"
                  value={document.model}
                  valid={true}
                  onChange={(event) => onChange(event)}
                />
              </div>
            </div>
          </div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">
            Identification du praticien et de la structure dans laquelle il
            exerce
          </h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div className="w-100">
                <Textarea
                  name="stamp"
                  label="Tampon du praticien*"
                  value={document.stamp}
                  valid={validation.stamp}
                  validationText="This question is required!"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="rpps"
                  label="Numéro du praticien (RPPS, ADELI)*"
                  value={document.rpps}
                  valid={validation.rpps}
                  validationText={
                    !document.rpps
                      ? 'This question is required!'
                      : isSubmitting
                      ? 'Invalid input'
                      : ''
                  }
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="organisationName"
                  label="Raison sociale de la structure*"
                  value={document.organisationName}
                  valid={validation.organisationName}
                  validationText="This question is required!"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Textarea
                  name="address"
                  label="Adresse de la structure*"
                  value={document.address}
                  valid={validation.address}
                  validationText="This question is required!"
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="finesId"
                  label="Numéro de la structure (FINESS, AM, SIRET)*"
                  value={document.finesId}
                  valid={validation.finesId}
                  validationText={
                    !document.finesId
                      ? 'This question is required!'
                      : isSubmitting
                      ? 'Invalid input'
                      : ''
                  }
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="w-100">
                <DateTimePicker
                  label="Date signature*"
                  name="dateSignature"
                  showYearDropdown={true}
                  showTimeInput={false}
                  value={document.dateSignature}
                  valid={validation.dateSignature}
                  validationText="This question is required!"
                  onChange={(value) =>
                    onDateChange({ field: 'dateSignature', value })
                  }
                />
              </div>
            </div>
          </div>
          <h4 className="midlightgrey f-small fw5 ttu mt15">
            Eléments d’ordre médical
          </h4>
          <div className="pa5 pt4 br4 shadow-1 bg-grouped-table mt2 flex flex-column justify-between">
            <div className="w-100 flex flex-column items-start justify-between margin-between">
              <div name="symptoms" className="input-group w-100">
                <label>Symptômes cliniques et pathologies*</label>
                {!validation.symptoms && (
                  <span className="error">This question is required!</span>
                )}
                <Checkbox
                  name="sleepiness"
                  label="Somnolence diurne"
                  checked={document.sleepiness}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="dailySnoring"
                  label="Ronflements sévères et quotidiens"
                  checked={document.dailySnoring}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="morningHeadaches"
                  label="Céphalées matinales"
                  checked={document.morningHeadaches}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="fatigue"
                  label="Fatigue diurne"
                  checked={document.fatigue}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="nocturia"
                  label="Nycturie"
                  checked={document.nocturia}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="suffocation"
                  label="Sensation d'étouffement ou de suffocation pendant le sommeil"
                  checked={document.suffocation}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="daytimeSleepiness"
                  label="Somnolence diurne sévère et/ou risque accidentel"
                  checked={document.daytimeSleepiness}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="cardiovascularComorbidity"
                  label="Comorbidité cardio-vasculaire associée grave"
                  checked={document.cardiovascularComorbidity}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                {document.cardiovascularComorbidity && (
                  <div className="w-100">
                    <Input
                      name="cardiovascularComorbidityDescription"
                      label="A préciser"
                      value={document.cardiovascularComorbidityDescription}
                      valid={true}
                      onChange={(event) => onChange(event)}
                    />
                  </div>
                )}
                <Checkbox
                  name="respiratoryComorbidity"
                  label="Comorbidité respiratoire associée grave"
                  checked={document.respiratoryComorbidity}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
              </div>
              {document.respiratoryComorbidity && (
                <div className="w-100">
                  <Input
                    name="respiratoryComorbidityDescription"
                    label="A préciser"
                    value={document.respiratoryComorbidityDescription}
                    valid={true}
                    onChange={(event) => onChange(event)}
                  />
                </div>
              )}
              <div className="w-100">
                <Radio
                  name="examination"
                  label="Examen réalisé*"
                  value={document.examination}
                  valid={validation.examination}
                  validationText="This question is required!"
                  options={EXAMINATION_OPTIONS}
                  onChange={(event) => onRadioChange(event)}
                />
              </div>
              <div className="w-100">
                <Input
                  name="iah"
                  label="IAH*"
                  placeholder={'0.0'}
                  value={document.iah}
                  valid={validation.iah}
                  validationText={
                    !document.iah
                      ? 'This question is required!'
                      : isSubmitting
                      ? 'Invalid input'
                      : ''
                  }
                  onChange={(event) => onChange(event)}
                />
              </div>
              <div className="input-group w-100">
                <label>Refus ou intolérance</label>
                <Checkbox
                  name="cpapIntolerance"
                  label="de la PPC"
                  checked={document.cpapIntolerance}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
                <Checkbox
                  name="oamIntolerance"
                  label="de l'OAM"
                  checked={document.oamIntolerance}
                  valid={true}
                  onChange={(event) => onCheckboxChange(event)}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

ViewComponent.propTypes = {
  onDateChange: PropTypes.func.isRequired,
  onChange: PropTypes.func,
  onCheckboxChange: PropTypes.func,
};

export default ViewComponent;
